import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { CTAButton } from './CTAButton';
export function FinalCTA() {
  return <SectionWrapper className="text-center" data-id="element-26">
      <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-8" data-id="element-27">
        El Protocolo Vientre Plano 40+
      </h2>
      <p className="text-xl text-gray-600 mb-10 max-w-2xl mx-auto" data-id="element-28">
        Desinflama tu abdomen hormonal en 7 días. Haz clic para obtener acceso
        instantáneo y comenzar tu reseteo.
      </p>
      <CTAButton data-id="element-29">¡SÍ, QUIERO MI VIENTRE PLANO 40+ AHORA!</CTAButton>
    </SectionWrapper>;
}